module.exports = __webpack_public_path__ + "img/symbol-one-seventh-left.c8d71355.png";